var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:pdf-02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.1665 21.0001V18.0834M8.1665 18.0834V16.3334C8.1665 15.7839 8.1665 15.5086 8.34617 15.3371C8.52584 15.1667 8.814 15.1667 9.3915 15.1667H10.2082C11.054 15.1667 11.74 15.8201 11.74 16.6251C11.74 17.4301 11.054 18.0834 10.2082 18.0834H8.1665ZM24.4998 15.1667H22.9692C22.0067 15.1667 21.5248 15.1667 21.2262 15.4514C20.9275 15.7361 20.9275 16.1946 20.9275 17.1116V18.0834M20.9275 18.0834V21.0001M20.9275 18.0834H23.479M18.3748 18.0834C18.3748 19.6934 17.004 21.0001 15.3123 21.0001C14.9308 21.0001 14.7407 21.0001 14.5972 20.9219C14.2577 20.7352 14.2915 20.3561 14.2915 20.0282V16.1386C14.2915 15.8107 14.2565 15.4316 14.5972 15.2449C14.7395 15.1667 14.9308 15.1667 15.3123 15.1667C17.004 15.1667 18.3748 16.4734 18.3748 18.0834Z",
    stroke: "#9E3039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 25.6667H12.5148C8.7115 25.6667 6.8075 25.6667 5.48683 24.7357C5.11099 24.4721 4.77505 24.1558 4.48933 23.7965C3.5 22.5529 3.5 20.7632 3.5 17.1815V14.2124C3.5 10.7555 3.5 9.02654 4.04717 7.64637C4.92683 5.42621 6.7865 3.67621 9.1455 2.84787C10.6108 2.33337 12.446 2.33337 16.121 2.33337C18.2187 2.33337 19.2687 2.33337 20.1063 2.62737C21.4538 3.10104 22.5167 4.10087 23.0195 5.36904C23.3333 6.15771 23.3333 7.14587 23.3333 9.12104V11.6667",
    stroke: "#9E3039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.5 14C3.5 12.9687 3.90968 11.9797 4.63892 11.2505C5.36815 10.5212 6.35721 10.1115 7.3885 10.1115C8.1655 10.1115 9.08133 10.2469 9.83617 10.045C10.166 9.95628 10.4667 9.78237 10.7081 9.54074C10.9495 9.29912 11.1232 8.99828 11.2117 8.66837C11.4135 7.91354 11.2782 6.99771 11.2782 6.22071C11.2785 5.18962 11.6883 4.20086 12.4175 3.47188C13.1467 2.74289 14.1356 2.33337 15.1667 2.33337",
    stroke: "#9E3039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.9c4ef1229f5b4cc7cb9513c5681b0402.svg";
export { ForwardRef as ReactComponent };